export default __webpack_public_path__ + "static/media/data-science-246x273.673853a0.png";